import React from 'react';
import { theme } from '@fiverr-private/theme';
import { L1_ICON_SIZES } from '../../constants';
import type { L1IconType } from '../../types';

const PlayCircleSolidL1Icon = ({ size = 'sm', color = 'currentColor' }: L1IconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={L1_ICON_SIZES[size]}
    height={L1_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 24 24"
  >
    <path
      fillRule="evenodd"
      d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12m5.571-11.258a.857.857 0 0 0 0-1.485L9.857 6.804a.857.857 0 0 0-1.286.742v8.908a.857.857 0 0 0 1.286.742z"
      clipRule="evenodd"
    />
  </svg>
);
PlayCircleSolidL1Icon.displayName = 'PlayCircleSolidL1Icon';
export default PlayCircleSolidL1Icon;
